var map = {
	"./assets-hhl/download/app_android.png": "158f",
	"./assets-hhl/download/app_android_d.png": "83a4",
	"./assets-hhl/download/app_ios.png": "f60a",
	"./assets-hhl/download/app_ios_d.png": "933b",
	"./assets-hhl/download/logo-retail.png": "6fce",
	"./assets-hhl/download/logo.png": "c10f",
	"./assets-hhl/download/logo_title.png": "5821",
	"./assets-hhl/download/retail_app.png": "4d2c",
	"./assets-hhl/download/success.png": "23dd",
	"./assets-hhl/img/apply/applyOversea.png": "ca53",
	"./assets-hhl/img/apply/applyOverseaen.png": "fe2f",
	"./assets-hhl/img/apply/applyOverseaen1.png": "7395",
	"./assets-hhl/img/apply/cityApply.png": "570d",
	"./assets-hhl/img/apply/cityApplyen.png": "7a2c",
	"./assets-hhl/img/apply/companyApply.png": "df68",
	"./assets-hhl/img/apply/companyApplyen.png": "034c",
	"./assets-hhl/img/apply/daishenhe.png": "db68",
	"./assets-hhl/img/apply/daishenheen.png": "69aa",
	"./assets-hhl/img/apply/personalApply.png": "5682",
	"./assets-hhl/img/apply/personalApplyen.png": "500f",
	"./assets-hhl/img/apply/provinceApply.png": "dcc8",
	"./assets-hhl/img/apply/provinceApplyen.png": "7c92",
	"./assets-hhl/img/apply/shenhe_gzh.png": "2153",
	"./assets-hhl/img/apply/tijiaochenggong.png": "294a",
	"./assets-hhl/img/apply/tijiaochenggongen.png": "4a49",
	"./assets-hhl/img/az/ArrowFatLineRight1@2x.png": "e5ad",
	"./assets-hhl/img/az/ArrowFatLineRight@2x.png": "6c50",
	"./assets-hhl/img/az/Frame 138@2x.png": "cda0",
	"./assets-hhl/img/az/Group 105@2x.png": "5877",
	"./assets-hhl/img/az/Group 106@2x.png": "7b34",
	"./assets-hhl/img/az/Mask Group1@2x.png": "c5a2",
	"./assets-hhl/img/az/Mask Group2@2x.png": "5c2a",
	"./assets-hhl/img/az/Mask Group@2x.png": "178e",
	"./assets-hhl/img/az/Mask Group@2x2.png": "0888",
	"./assets-hhl/img/az/Vector1@2x.png": "5e0b",
	"./assets-hhl/img/az/Vector@2x.png": "6a44",
	"./assets-hhl/img/az/a_logo@2x.png": "3969",
	"./assets-hhl/img/az/and_online_eq.png": "2cd4",
	"./assets-hhl/img/az/android_1@2x.png": "1686",
	"./assets-hhl/img/az/arrow_2023_07_19.png": "3188",
	"./assets-hhl/img/az/az_bg_2023_01_19.png": "f9c2",
	"./assets-hhl/img/az/az_online.png": "2eab",
	"./assets-hhl/img/az/az_outline.png": "74ae",
	"./assets-hhl/img/az/azlogo-01 3@2x.png": "2945",
	"./assets-hhl/img/az/earth.png": "06cd",
	"./assets-hhl/img/az/go.png": "b32b",
	"./assets-hhl/img/az/ios_online_eq.png": "22e4",
	"./assets-hhl/img/az/outline_new_android.png": "3b16",
	"./assets-hhl/img/az/outline_new_android_2023_02_23.png": "4c8c",
	"./assets-hhl/img/az/quanqiugou_android_cdn.png": "9036",
	"./assets-hhl/img/az/wap_font@2x.png": "0dd2",
	"./assets-hhl/img/az/wap_logo@2x.png": "4ffc",
	"./assets-hhl/img/ditui/logo.png": "d499",
	"./assets-hhl/img/index/Group 6852@2x.png": "bfa7",
	"./assets-hhl/img/index/Group 6853@2x.png": "391f",
	"./assets-hhl/img/index/Group 6854@2x.png": "2c69",
	"./assets-hhl/img/index/LOGO 2@2x.png": "e091",
	"./assets-hhl/img/index/LOGO 2_1@2x.png": "bc46",
	"./assets-hhl/img/index/Rectangle 225@2x.png": "d7e5",
	"./assets-hhl/img/index/azg_1@2x.png": "977a",
	"./assets-hhl/img/index/azg_left1@2x.png": "8069",
	"./assets-hhl/img/index/index_homel1.png": "1c26",
	"./assets-hhl/img/index/logo.png": "d034",
	"./assets-hhl/img/index/wapRectangle 247@2x.png": "4f5b",
	"./assets-hhl/img/index/x3.png": "2386",
	"./assets-hhl/img/index/xen3.png": "dfa9",
	"./assets-hhl/img/login/LOGO 2@2x.png": "e941",
	"./assets-hhl/img/login/Mask Group@2x.png": "7b98",
	"./assets-hhl/img/questions/pic1.png": "b639",
	"./assets-hhl/img/shouye/Frame 178.png": "4887",
	"./assets-hhl/img/shouye/Group 124@2x.png": "60b8",
	"./assets-hhl/img/shouye/Group 125@2x.png": "408b",
	"./assets-hhl/img/shouye/Group 126@2x.png": "c1c9",
	"./assets-hhl/img/shouye/Group 127@2x.png": "1ab8",
	"./assets-hhl/img/shouye/Group 6858.png": "631f",
	"./assets-hhl/img/shouye/Mask Group@2x.png": "4b5b",
	"./assets-hhl/img/shouye/Rectangle 145@2x.png": "4c92",
	"./assets-hhl/img/shouye/Rectangle 148@2x.png": "bc68",
	"./assets-hhl/img/shouye/azg_反白 1@2x.png": "6245",
	"./assets-hhl/img/swper_end220422/1.png": "8253",
	"./assets-hhl/img/swper_end220422/11.png": "c190",
	"./assets-hhl/img/swper_end220422/11_2023_01_18.png": "424a",
	"./assets-hhl/img/swper_end220422/11_2023_07_19.png": "7058",
	"./assets-hhl/img/swper_end220422/11_2023_11_20.png": "06e3",
	"./assets-hhl/img/swper_end220422/11_2024_08_23.png": "7d91",
	"./assets-hhl/img/swper_end220422/1_2023_01_18.png": "4094",
	"./assets-hhl/img/swper_end220422/1_2023_11_20.png": "ab23",
	"./assets-hhl/img/swper_end220422/1_2024_08_23.png": "45bd",
	"./assets-hhl/img/swper_end220422/3111fc3a9cdf5be6a096b79ec0029cf8a8731cd4450c2-7xn8mT.png": "918d",
	"./assets-hhl/img/wapdownload/az_haohuotong_logo.png": "94bb",
	"./assets-hhl/img/wapdownload/az_quanqiugou_logo.png": "f718",
	"./assets-hhl/index/footer_logo.png": "d5a3",
	"./assets-hhl/index/logo.png": "8871",
	"./assets-hhl/index/logo@2x.png": "188f",
	"./assets-hhl/index/logo_bott@2x.png": "83c2",
	"./assets-hhl/mine/inform/myazgo2019@2x.png": "07d9",
	"./assets-mc/download/app_android.png": "3971",
	"./assets-mc/download/app_android_d.png": "708f",
	"./assets-mc/download/app_ios.png": "107ae",
	"./assets-mc/download/app_ios_d.png": "e31e",
	"./assets-mc/download/logo-retail.png": "7033",
	"./assets-mc/download/logo.png": "ac48",
	"./assets-mc/download/logo_title.png": "afcb",
	"./assets-mc/download/retail_app.png": "b055",
	"./assets-mc/download/success.png": "4425",
	"./assets-mc/img/apply/applyOversea.png": "b2b7",
	"./assets-mc/img/apply/applyOverseaen.png": "32f9",
	"./assets-mc/img/apply/applyOverseaen1.png": "b9c0",
	"./assets-mc/img/apply/cityApply.png": "40e6",
	"./assets-mc/img/apply/cityApplyen.png": "7cca",
	"./assets-mc/img/apply/companyApply.png": "0843",
	"./assets-mc/img/apply/companyApplyen.png": "8e76",
	"./assets-mc/img/apply/daishenhe.png": "718e",
	"./assets-mc/img/apply/daishenheen.png": "5eba",
	"./assets-mc/img/apply/personalApply.png": "d058",
	"./assets-mc/img/apply/personalApplyen.png": "b81d",
	"./assets-mc/img/apply/provinceApply.png": "baa6",
	"./assets-mc/img/apply/provinceApplyen.png": "ed6d",
	"./assets-mc/img/apply/shenhe_gzh.png": "fe2f4",
	"./assets-mc/img/apply/tijiaochenggong.png": "f163",
	"./assets-mc/img/apply/tijiaochenggongen.png": "1cb9",
	"./assets-mc/img/az/ArrowFatLineRight1@2x.png": "9167",
	"./assets-mc/img/az/ArrowFatLineRight@2x.png": "ed16",
	"./assets-mc/img/az/Frame 138@2x.png": "4195",
	"./assets-mc/img/az/Group 105@2x.png": "82aa",
	"./assets-mc/img/az/Group 106@2x.png": "1051",
	"./assets-mc/img/az/Mask Group1@2x.png": "6a9d",
	"./assets-mc/img/az/Mask Group2@2x.png": "e2c4",
	"./assets-mc/img/az/Mask Group@2x.png": "960a",
	"./assets-mc/img/az/Mask Group@2x2.png": "eac9",
	"./assets-mc/img/az/Vector1@2x.png": "484a",
	"./assets-mc/img/az/Vector@2x.png": "535d",
	"./assets-mc/img/az/a_logo@2x.png": "994b",
	"./assets-mc/img/az/and_online_eq.png": "60df",
	"./assets-mc/img/az/android_1@2x.png": "811d",
	"./assets-mc/img/az/arrow_2023_07_19.png": "33b7",
	"./assets-mc/img/az/az_bg_2023_01_19.png": "fb73",
	"./assets-mc/img/az/az_online.png": "de2e",
	"./assets-mc/img/az/az_outline.png": "58a9",
	"./assets-mc/img/az/azlogo-01 3@2x.png": "7b6b",
	"./assets-mc/img/az/earth.png": "018f",
	"./assets-mc/img/az/go.png": "96cc",
	"./assets-mc/img/az/ios_online_eq.png": "e075",
	"./assets-mc/img/az/outline_new_android.png": "18c0",
	"./assets-mc/img/az/outline_new_android_2023_02_23.png": "a8ad",
	"./assets-mc/img/az/quanqiugou_android_cdn.png": "98ca",
	"./assets-mc/img/az/wap_font@2x.png": "135f",
	"./assets-mc/img/az/wap_logo@2x.png": "b2f1",
	"./assets-mc/img/ditui/logo.png": "123d",
	"./assets-mc/img/index/Group 6852@2x.png": "a847",
	"./assets-mc/img/index/Group 6853@2x.png": "8162",
	"./assets-mc/img/index/Group 6854@2x.png": "f5fa",
	"./assets-mc/img/index/LOGO 2@2x.png": "74e9",
	"./assets-mc/img/index/LOGO 2_1@2x.png": "34a0",
	"./assets-mc/img/index/Rectangle 225@2x.png": "590f",
	"./assets-mc/img/index/azg_1@2x.png": "af43",
	"./assets-mc/img/index/azg_left1@2x.png": "203d",
	"./assets-mc/img/index/index_homel1.png": "61b9",
	"./assets-mc/img/index/logo.png": "90b8",
	"./assets-mc/img/index/wapRectangle 247@2x.png": "7401",
	"./assets-mc/img/index/x3.png": "f859",
	"./assets-mc/img/index/xen3.png": "ab6b",
	"./assets-mc/img/login/LOGO 2@2x.png": "c3e6",
	"./assets-mc/img/login/Mask Group@2x.png": "0687",
	"./assets-mc/img/questions/pic1.png": "36d0",
	"./assets-mc/img/shouye/Frame 178.png": "16a7",
	"./assets-mc/img/shouye/Group 124@2x.png": "8b85",
	"./assets-mc/img/shouye/Group 125@2x.png": "4b45",
	"./assets-mc/img/shouye/Group 126@2x.png": "5b75",
	"./assets-mc/img/shouye/Group 127@2x.png": "3c24",
	"./assets-mc/img/shouye/Group 6858.png": "e94d",
	"./assets-mc/img/shouye/Mask Group@2x.png": "49dd",
	"./assets-mc/img/shouye/Rectangle 145@2x.png": "e2e0",
	"./assets-mc/img/shouye/Rectangle 148@2x.png": "fb5d",
	"./assets-mc/img/shouye/azg_反白 1@2x.png": "804f",
	"./assets-mc/img/swper_end220422/1.png": "7134",
	"./assets-mc/img/swper_end220422/11.png": "a822f",
	"./assets-mc/img/swper_end220422/11_2023_01_18.png": "caf9",
	"./assets-mc/img/swper_end220422/11_2023_07_19.png": "68d9",
	"./assets-mc/img/swper_end220422/11_2023_11_20.png": "041c",
	"./assets-mc/img/swper_end220422/11_2024_08_23.png": "276c",
	"./assets-mc/img/swper_end220422/1_2023_01_18.png": "8403",
	"./assets-mc/img/swper_end220422/1_2023_11_20.png": "a3ac",
	"./assets-mc/img/swper_end220422/1_2024_08_23.png": "6c2f",
	"./assets-mc/img/swper_end220422/3111fc3a9cdf5be6a096b79ec0029cf8a8731cd4450c2-7xn8mT.png": "2941",
	"./assets-mc/img/wapdownload/az_haohuotong_logo.png": "40f5",
	"./assets-mc/img/wapdownload/az_quanqiugou_logo.png": "3873",
	"./assets-mc/index/footer_logo.png": "918d3",
	"./assets-mc/index/logo.png": "6e90",
	"./assets-mc/index/logo@2x.png": "97bc",
	"./assets-mc/index/logo_bott@2x.png": "2be5",
	"./assets-mc/mine/inform/myazgo2019@2x.png": "55bb",
	"./brand/brand1.png": "a817",
	"./brand/brand2.png": "062b",
	"./brand/brand3.png": "bc60",
	"./brand/brand4.png": "81d1",
	"./brand/brand5.png": "09a4",
	"./brand/brand6.png": "4928",
	"./brand/brand7.png": "23b4",
	"./brand/brand8.png": "1529",
	"./brand/brand9.png": "cb9e",
	"./download/android.png": "e454",
	"./download/app.png": "abb0",
	"./download/app_android.png": "f16f",
	"./download/app_android_d.png": "d9bb",
	"./download/app_android_d_error.png": "eaa4",
	"./download/app_d.png": "4527",
	"./download/app_dd.png": "f241",
	"./download/app_ios.png": "45c6",
	"./download/app_ios_d.png": "9e25",
	"./download/arrow.png": "23d8",
	"./download/bg.png": "c7b7",
	"./download/guid.png": "2b86",
	"./download/ios.png": "a1b9",
	"./download/logo-retail.png": "5e9a9",
	"./download/logo.png": "0b5c",
	"./download/logo_title.png": "60d5",
	"./download/retail_app.png": "e53b",
	"./download/success.png": "f4ed",
	"./download/success1.png": "a736",
	"./img/apply/11651611730720_ 1@2x.png": "314c",
	"./img/apply/applyOverseaen1.png": "b49c",
	"./img/apply/authorizationUrl.png": "d9cd",
	"./img/apply/basic _ circle_check_outline@2x.png": "f046",
	"./img/apply/brandLogo.png": "0d75",
	"./img/apply/businessLicenseUrl.png": "8b1b",
	"./img/apply/businessLicenseUrl_shili.png": "1150",
	"./img/apply/certificationPicUrl.png": "fa9b",
	"./img/apply/coolicon@2x.png": "fd5c",
	"./img/apply/coolicon_1@2x.png": "471b",
	"./img/apply/email icon@2x.png": "51a1",
	"./img/apply/idcardBackUrl.png": "3304",
	"./img/apply/idcardBackUrl_shili.png": "c99f",
	"./img/apply/idcardFrontUrl.png": "3b04",
	"./img/apply/idcardFrontUrl_shili.png": "6032",
	"./img/apply/idcardHandUrl.png": "271f",
	"./img/apply/idcardHandUrl_shili.png": "b7d6",
	"./img/apply/idcardUrl.png": "ee34",
	"./img/apply/left_icon.png": "73ee",
	"./img/apply/lijiruzhu.png": "f0dd",
	"./img/apply/message icon@2x.png": "c26d",
	"./img/apply/provinceApply.png": "8aef",
	"./img/apply/quan.png": "6a1d",
	"./img/apply/quan_wei.png": "0d73",
	"./img/apply/registerCertificationUrl.png": "ce50",
	"./img/apply/salesAuthorizationLetterUrl.png": "5335",
	"./img/apply/shopLogo.png": "f9d1",
	"./img/apply/trademarkOwnerOthers.png": "ded0",
	"./img/apply/user icon@2x.png": "4c72",
	"./img/az/111@2x.png": "43bf",
	"./img/az/11@2x.png": "aaad",
	"./img/az/1@2x.png": "8afe",
	"./img/az/1_111@2x.png": "3ac6",
	"./img/az/1_11@2x.png": "852e",
	"./img/az/1_1@2x.png": "c955",
	"./img/az/1_222@2x.png": "528c",
	"./img/az/1_22@2x.png": "6aba",
	"./img/az/1_2@2x.png": "d868",
	"./img/az/1_333@2x.png": "f016",
	"./img/az/1_33@2x.png": "2044",
	"./img/az/1_3@2x.png": "1c6a",
	"./img/az/1_444@2x.png": "e3a5",
	"./img/az/1_4@2x.png": "5dff",
	"./img/az/1_5@2x.png": "e418",
	"./img/az/222@2x.png": "44ea",
	"./img/az/22@2x.png": "ac85",
	"./img/az/2@2x.png": "50a7",
	"./img/az/333@2x.png": "741d",
	"./img/az/33@2x.png": "3592",
	"./img/az/3@2x.png": "f35e",
	"./img/az/444@2x.png": "605b",
	"./img/az/4@2x.png": "5bb0",
	"./img/az/5@2x.png": "536a",
	"./img/az/ArrowFatLineRight1@2x.png": "e959",
	"./img/az/ArrowFatLineRight@2x.png": "d3a6",
	"./img/az/Frame 138@2x.png": "47f9",
	"./img/az/Group 105@2x.png": "d7c3",
	"./img/az/Group 106@2x.png": "cddd",
	"./img/az/Group 6825.png": "b1ae",
	"./img/az/Group 6825@2x.png": "5c8a",
	"./img/az/Group 6826@2x.png": "56f1",
	"./img/az/Group 6830@2x.png": "3be9",
	"./img/az/Group 6831@2x.png": "17a9",
	"./img/az/Mask Group1@2x.png": "3341",
	"./img/az/Mask Group2@2x.png": "45a0",
	"./img/az/Rectangle 252@2x.png": "f819",
	"./img/az/Vector1@2x.png": "f924",
	"./img/az/Vector@2x.png": "4eda",
	"./img/az/a_logo@2x.png": "4f91",
	"./img/az/and_online_eq.png": "852e6",
	"./img/az/android_1@2x.png": "0fa2",
	"./img/az/arrow_2023_07_19.png": "ceea",
	"./img/az/az_bg_2023_01_19.png": "1957",
	"./img/az/az_online.png": "d4fa",
	"./img/az/az_outline.png": "75cf",
	"./img/az/azlogo-01 3@2x.png": "5a29",
	"./img/az/earth.png": "1b5c",
	"./img/az/go.png": "cb23",
	"./img/az/intr@2x.png": "7232",
	"./img/az/ios_1@2x.png": "85c4",
	"./img/az/ios_online_eq.png": "8d20",
	"./img/az/online_bg_2023_01_19.png": "1fa9",
	"./img/az/online_bg_2023_01_19_2.png": "fa5f",
	"./img/az/online_bg_2025_04_25.png": "9872",
	"./img/az/online_bg_wap_2023_01_19.png": "1845",
	"./img/az/online_bg_wap_2023_01_19_2.png": "eacf",
	"./img/az/online_bg_wap_2025_04_25.png": "ca2a",
	"./img/az/outline_bg_2023_01_19.png": "2edc",
	"./img/az/outline_bg_2025_04_25.png": "5061",
	"./img/az/outline_bg_wap_2023_01_19.png": "bac4",
	"./img/az/outline_bg_wap_2025_04_25.png": "6204",
	"./img/az/outline_new@2x.png": "ab20",
	"./img/az/outline_new_android.png": "c74a",
	"./img/az/outline_new_android_2023_02_23.png": "9c8b",
	"./img/az/outline_new_wap@2x.png": "e366",
	"./img/az/quanqiugou_android_cdn.png": "2bb0",
	"./img/az/wap_font@2x.png": "0430",
	"./img/az/wap_logo@2x.png": "c483",
	"./img/az/wap_phone1@2x.png": "ee0be",
	"./img/az/wap_phone@2x.png": "076d",
	"./img/az/wapintr@2x.png": "c3cb",
	"./img/az_down/and_download_icon.png": "0445",
	"./img/az_down/android_az_web_code.png": "f051",
	"./img/az_down/aoxingou.png": "11da",
	"./img/az_down/aoxintong.png": "705b",
	"./img/az_down/aoxintong_2025_04_25.png": "c7a7",
	"./img/az_down/apple_aoxingou_code.png": "4379",
	"./img/az_down/apple_aoxintong_code.png": "eadc",
	"./img/az_down/apple_download_icon.png": "5b56",
	"./img/az_down/az_bg_2023_01_19.png": "4a82",
	"./img/az_down/az_bg_2025_04_25.png": "38e9",
	"./img/ditui/address.png": "2850",
	"./img/ditui/email.png": "765f",
	"./img/ditui/inviteCode.png": "5a98",
	"./img/ditui/lock.png": "0af8",
	"./img/ditui/logo.png": "bddb",
	"./img/ditui/phone.png": "c144",
	"./img/ditui/select.png": "a579",
	"./img/ditui/shop.png": "0752",
	"./img/ditui/top_bg.png": "b210",
	"./img/ditui/unselect.png": "9816",
	"./img/index/Close _ 24 _ Outline@2x.png": "f1da",
	"./img/index/Close _ 24 _ Outline_white@2x.png": "55b5",
	"./img/index/Group 6823@2x.png": "ed7b",
	"./img/index/Group 6823_2@2x.png": "604c",
	"./img/index/Group 6848@2x.png": "46b5",
	"./img/index/Group 6849@2x.png": "31e3",
	"./img/index/Group 6850@2x.png": "b1a3",
	"./img/index/Group 6852@2x.png": "89bd",
	"./img/index/Group 6853@2x.png": "76bf",
	"./img/index/Group 6854@2x.png": "1be9",
	"./img/index/LOGO 2@2x.png": "6033",
	"./img/index/LOGO 2_1@2x.png": "8dcc",
	"./img/index/Mask Group.png": "eff6",
	"./img/index/Rectangle 1451@2x.png": "a334",
	"./img/index/Rectangle 147@2x.png": "ab33",
	"./img/index/Rectangle 1481@2x.png": "aa69",
	"./img/index/Rectangle 225@2x.png": "0976",
	"./img/index/Rectangle 251@2x.png": "a699",
	"./img/index/azg_1@2x.png": "82f6",
	"./img/index/azg_left1@2x.png": "ab22",
	"./img/index/bar_right1@2x.png": "8f51",
	"./img/index/f128bbd1fe1b87ebd8cde48ed8eb7bc.png": "649b",
	"./img/index/go_more1@2x.png": "ba30",
	"./img/index/go_more@2x.png": "7924",
	"./img/index/image 28@2x.png": "d364",
	"./img/index/index_homel1.png": "3d46",
	"./img/index/loop@2x.png": "a7fc",
	"./img/index/wapRectangle 247@2x.png": "c0f5",
	"./img/index/wap_loop@2x.png": "caac",
	"./img/index/x1_2023_01_19@2x.png": "b877",
	"./img/index/x1_2025_04_25@2x.png": "a00f",
	"./img/index/x1_en_2023_01_19@2x.png": "915b",
	"./img/index/x1_en_2025_04_25@2x.png": "4995",
	"./img/index/x2_2025_04_25@2x.png": "a5cc",
	"./img/index/x2_en_2025_04_25@2x.png": "5c74",
	"./img/index/x3_2025_04_25@2x.png": "d9d7",
	"./img/index/x3_en_2025_04_25@2x.png": "872a",
	"./img/login/Ellipse 22@2x.png": "558f",
	"./img/login/LOGO 2@2x.png": "aa6c",
	"./img/login/Mask Group@2x.png": "1d7a",
	"./img/login/nengkan.png": "7730",
	"./img/login/nengkan_bu.png": "fb1f",
	"./img/login/xuanzhong.png": "bb7d",
	"./img/questions/pic1.png": "bf30",
	"./img/questions/pic2.png": "9bb8",
	"./img/shouye/Component 13@2x.png": "5176",
	"./img/shouye/Component 14@2x.png": "8b9b",
	"./img/shouye/Frame 11@2x.png": "e61e",
	"./img/shouye/Frame 12@2x.png": "f582",
	"./img/shouye/Frame 13@2x.png": "a6ae",
	"./img/shouye/Frame 14@2x.png": "53de",
	"./img/shouye/Group 124@2x.png": "333f",
	"./img/shouye/Group 125@2x.png": "6e12",
	"./img/shouye/Group 126@2x.png": "0f97",
	"./img/shouye/Group 127@2x.png": "518d",
	"./img/shouye/Group 57@2x.png": "aef4",
	"./img/shouye/Group 58@2x.png": "2a8e",
	"./img/shouye/Group 59@2x.png": "b61f",
	"./img/shouye/Group 62@2x.png": "8124",
	"./img/shouye/Group 87@2x.png": "adbe",
	"./img/shouye/Mask Group@2x.png": "4f20",
	"./img/shouye/Mask Group_1@2x.png": "f8f6",
	"./img/shouye/Mask Group_2@2x.png": "94e5",
	"./img/shouye/Rectangle 145@2x.png": "18bf",
	"./img/shouye/Rectangle 147@2x.png": "d539",
	"./img/shouye/Rectangle 148@2x.png": "9f84",
	"./img/shouye/azg_反白 1@2x.png": "61bea",
	"./img/shouye/b5efb3787d2aea7d84a8b43c28a58ab.png": "a2ec",
	"./img/shouye/some_on_1@2x.png": "e7d0",
	"./img/swper_end220422/11_2023_11_20.png": "0463",
	"./img/swper_end220422/11_2024_08_23.png": "6622",
	"./img/swper_end220422/1_2023_11_20.png": "17d4",
	"./img/swper_end220422/1_2024_08_23.png": "1822",
	"./img/swper_end251210/pc_01.png": "254e",
	"./img/swper_end251210/pc_02.png": "9a67",
	"./img/swper_end251210/pc_03.png": "0e85",
	"./img/swper_end251210/wap_01.png": "4f10",
	"./img/swper_end251210/wap_02.png": "7d26",
	"./img/swper_end251210/wap_03.png": "c1dc",
	"./img/wapdownload/android_download_btn.png": "e9a8",
	"./img/wapdownload/az_haohuotong_logo.png": "7a83",
	"./img/wapdownload/az_quanqiugou_logo.png": "c33b",
	"./img/wapdownload/ios_download_btn.png": "830b",
	"./img/wapindex/wapban3.png": "6f67",
	"./index/bottom.png": "572d",
	"./index/det1.png": "61e5",
	"./index/det2.png": "9a97",
	"./index/det3.png": "8f45",
	"./index/footer_logo.png": "4c39",
	"./index/location.png": "a43f",
	"./index/logo.png": "a780",
	"./index/logo1.png": "f229",
	"./index/logo10.png": "95ce",
	"./index/logo2.png": "2b82",
	"./index/logo3.png": "9276",
	"./index/logo4.png": "7db0",
	"./index/logo5.png": "07c6",
	"./index/logo6.png": "31c5",
	"./index/logo7.png": "79c9",
	"./index/logo8.png": "7f09",
	"./index/logo9.png": "3fb0",
	"./index/logo@2x.png": "f8d4",
	"./index/logo_bott@2x.png": "aff9",
	"./index/menu.png": "25a9",
	"./index/menu_close.png": "b339",
	"./index/top_bg1.png": "d70b",
	"./index/top_bg1_p.png": "fc0a",
	"./mine/inform/1.1@2x.png": "285b",
	"./mine/inform/1@2x.png": "f967",
	"./mine/inform/2.2@2x.png": "a83b",
	"./mine/inform/2@2x.png": "bbd9",
	"./mine/inform/3.3@2x.png": "06ca",
	"./mine/inform/3@2x.png": "8714",
	"./mine/inform/4.4@2x.png": "4222",
	"./mine/inform/4@2x.png": "9c9b",
	"./mine/inform/5.5@2x.png": "e934",
	"./mine/inform/5@2x.png": "9389",
	"./mine/inform/6.6@2x.png": "7130",
	"./mine/inform/6@2x.png": "fd38",
	"./mine/inform/7@2x.png": "7017",
	"./mine/inform/icon_call@2x.png": "f184",
	"./mine/inform/icon_service@2x.png": "51ed",
	"./mine/inform/login@2x.png": "b9c5",
	"./mine/inform/myazgo2019@2x.png": "99ed",
	"./mine/inform/q1.png": "ae82",
	"./mine/inform/q2.png": "071b",
	"./mine/inform/q3.png": "77f0",
	"./mine/inform/q4.png": "a5dd",
	"./mine/inform/q5.png": "c29b",
	"./mine/inform/q6.png": "34fb",
	"./mine/inform/q7.png": "007d",
	"./register/eye_close.png": "27f1",
	"./register/eye_open.png": "3ff9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";